import UserLayout from './UserLayout';

const OtherRoutesLayout = () => {
  return <UserLayout />;
};

export default OtherRoutesLayout;
